/* RESPONSIBLE TEAM: team-frontend-tech */
import Predicate from 'predicates/models/predicate';
import { inject as service } from '@ember/service';
import { readOnly, map } from '@ember/object/computed';
import { computed } from '@ember/object';
import FiltersToText from 'embercom/lib/filters-to-text';
import DefaultPredicateComparisonOptions from 'predicates/models/data/default-predicate-comparison-options';
export default Predicate.extend({
  appService: service(),
  intl: service(),
  isEditable: true,
  genericType: 'teamCapacity',
  defaultComparison: 'contains',
  description: computed('attribute', 'value', 'comparison', 'type', 'genericType', 'intl.locale', 'teams.length', function () {
    let filterMap = {
      [this.type]: DefaultPredicateComparisonOptions[this.genericType]
    };
    let localizedComparator = this.intl.t(`common.predicates.team-capacity.${this.comparison === 'contains' ? 'has-capacity' : 'no-capacity'}`);
    return this.teams.length > 0 ? `${FiltersToText.getValue(this, filterMap)} ${localizedComparator}`.trim() : this.intl.t('common.predicates.team-capacity.select-label');
  }),
  teams: readOnly('appService.app.teams'),
  options: map('teams', function (team) {
    return {
      text: team.name,
      value: team.id
    };
  }),
  getDefaultValue() {
    return this.get('options.firstObject.value') ?? undefined;
  },
  isValid: computed('value', 'comparison', function () {
    return ['contains', 'not_contains'].includes(this.comparison) && !!this.value;
  })
});